import { chatbotApi } from '@/config.ts';
import type { BlogPost } from '@/data/blogData';

type GeneratedPostRaw = BlogPost & {
  expiresAt?: string;
  sources?: { title: string; url: string }[];
  generated?: boolean;
};

function normalizePost(raw: GeneratedPostRaw): BlogPost {
  return {
    id: raw.id,
    slug: raw.slug,
    title: raw.title,
    excerpt: raw.excerpt,
    content: raw.content,
    coverImage: raw.coverImage,
    author: raw.author,
    category: raw.category,
    tags: raw.tags ?? [],
    publishedAt: raw.publishedAt,
    readTime: raw.readTime,
    featured: Boolean(raw.featured),
  };
}

export async function fetchGeneratedPosts(): Promise<BlogPost[]> {
  try {
    const res = await fetch(`${chatbotApi}/blog/posts`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return [];
    const data = (await res.json()) as { posts?: GeneratedPostRaw[] };
    return (data.posts ?? []).map(normalizePost);
  } catch {
    return [];
  }
}

export async function fetchGeneratedPostBySlug(slug: string): Promise<BlogPost | null> {
  try {
    const res = await fetch(`${chatbotApi}/blog/posts/${encodeURIComponent(slug)}`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    const data = (await res.json()) as GeneratedPostRaw;
    return normalizePost(data);
  } catch {
    return null;
  }
}
